import React from 'react';
import PropTypes from "prop-types";

import './statisticChat.less';

const StatisticChat = ({ statisticChat }) => {
  return (
    <div className="statistic-chat">
      <h3>Statistic for all chats</h3>
      <p>Total count chats: <span>{statisticChat ? statisticChat.chatsCount : '0'}</span></p>
      <p>Total count messages: <span>{statisticChat ? statisticChat.totalMessageCount : '0'}</span></p>
    </div>
  )
};

StatisticChat.propTypes = {
  statisticChat: PropTypes.object
};

export default StatisticChat;



// WEBPACK FOOTER //
// ./src/components/Modules/Statistics/StatisticChat/StatisticChat.js